import React, { Component }  from 'react';
import { withRouter }        from 'react-router';
import { connect }           from 'react-redux';
import { Redirect }          from 'react-router-dom';
import PubSubBreadcrumb      from './Breadcrumb';
import Execute               from './User/Execute';
import List                  from './Admin/List';
import { PubSubConstants }   from './environment';
import Required              from '../../Required';
import { isLoggedIn }        from '../../../utils/authService';
import { isInRoleFromToken } from '../../../utils/authService';
import { redirect }          from '../../../utils/authService'; 

class PubSub extends Component {
  
  componentDidMount() {
    document.title = document.title.split("|")[0] + ' | PubSub';
  }

  render() {
    var path = this.props.location.pathname.toLowerCase();    
    if (!isLoggedIn()) {
      redirect(path.replace(/^\/|\/$/g, ''));
      return (
        <Required />
      );
    }
        
    let content = null;
    if (isInRoleFromToken(PubSubConstants.AdminRole)) {
      let component = null;
      if (path.endsWith(PubSubConstants.PathPrefix)) {
        component = <Execute />;
      }
      else if (path.startsWith(PubSubConstants.AdminPathPrefix + '/execute')) {
        component = <Execute />;
      }
      else if (path.startsWith(PubSubConstants.AdminPathPrefix + '/list')) {
        component = <List />;  
      }
      else {
        // No idea what path here
      }
      
      content = 
        <div>
          <PubSubBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else if (PubSubConstants.UserRole === "*" || isInRoleFromToken(PubSubConstants.UserRole)) {
      let component = null;
      if (path.endsWith(PubSubConstants.PathPrefix)) {
        component = <Execute />;
      }
      else if (path.startsWith(PubSubConstants.UserPathPrefix + '/execute')) {
        component = <Execute />;
      }
      else {
        // No idea what path here
      }
      
      content = 
        <div>
          <PubSubBreadcrumb {...this.props} />
          {component}
        </div>;
    }
    else {
      return <Redirect to='/404' />;
    }

    return (
      <div>
        {content}
      </div>
    );
  }
}

const mapStateToProps = state => ({ 
  pubsub: state.pubsub
});

export default withRouter(connect(mapStateToProps)(PubSub));
